/**
 * Locale to Apple Wallet badge folder mapping
 * Maps standard locale codes (e.g., 'fr-FR', 'en-US') to Apple's folder structure
 */
export const LOCALE_TO_APPLE_FOLDER: { [key: string]: string } = {
    // French
    fr: 'FR',
    'fr-fr': 'FR',
    'fr-be': 'FR',
    'fr-ch': 'FR',
    'fr-ca': 'CAFR',

    // English
    en: 'US_UK',
    'en-us': 'US_UK',
    'en-gb': 'US_UK',
    'en-ca': 'US_UK',
    'en-au': 'US_UK',
    'en-nz': 'US_UK',

    // Spanish
    es: 'ES',
    'es-es': 'ES',
    'es-mx': 'ESMX',

    // Portuguese
    pt: 'PT',
    'pt-pt': 'PT',
    'pt-br': 'PTBR',

    // German
    de: 'DE',
    'de-de': 'DE',
    'de-at': 'DE',
    'de-ch': 'DE',

    // Italian
    it: 'IT',
    'it-it': 'IT',

    // Dutch
    nl: 'NL',
    'nl-nl': 'NL',
    'nl-be': 'NL',

    // Polish
    pl: 'PL',
    'pl-pl': 'PL',

    // Russian
    ru: 'RU',
    'ru-ru': 'RU',

    // Turkish
    tr: 'TR',
    'tr-tr': 'TR',

    // Arabic
    ar: 'AR',

    // Japanese
    ja: 'JP',
    'ja-jp': 'JP',

    // Korean
    ko: 'KR',
    'ko-kr': 'KR',

    // Chinese
    'zh-cn': 'CN',
    'zh-tw': 'TWTC',
    'zh-hk': 'HK',

    // Other European languages
    sv: 'SE', // Swedish
    'sv-se': 'SE',
    no: 'NO', // Norwegian
    'nb-no': 'NO',
    da: 'DK', // Danish
    'da-dk': 'DK',
    fi: 'FI', // Finnish
    'fi-fi': 'FI',
    cs: 'CZ', // Czech
    'cs-cz': 'CZ',
    sk: 'SK', // Slovak
    'sk-sk': 'SK',
    hu: 'HU', // Hungarian
    'hu-hu': 'HU',
    ro: 'RO', // Romanian
    'ro-ro': 'RO',
    bg: 'BG', // Bulgarian
    'bg-bg': 'BG',
    hr: 'HR', // Croatian
    'hr-hr': 'HR',
    sl: 'SI', // Slovenian
    'sl-si': 'SI',
    et: 'EE', // Estonian
    'et-ee': 'EE',
    lv: 'LV', // Latvian
    'lv-lv': 'LV',
    lt: 'LT', // Lithuanian
    'lt-lt': 'LT',
    uk: 'UA', // Ukrainian
    'uk-ua': 'UA',
    el: 'GR', // Greek
    'el-gr': 'GR',
    mt: 'MT', // Maltese
    'mt-mt': 'MT',

    // Asian languages
    th: 'TH', // Thai
    'th-th': 'TH',
    vi: 'VN', // Vietnamese
    'vi-vn': 'VN',
    id: 'ID', // Indonesian
    'id-id': 'ID',
    ms: 'MY', // Malay
    'ms-my': 'MY',
    tl: 'PH', // Filipino/Tagalog
    fil: 'PH',
    hi: 'IN', // Hindi
    'hi-in': 'IN',
    he: 'HB', // Hebrew
    'he-il': 'HB',
    az: 'AZ', // Azerbaijani
    'az-az': 'AZ',
};

/**
 * Default folder code when locale is not found
 */
export const DEFAULT_APPLE_FOLDER = 'US_UK';

/**
 * Maps a locale code to an Apple Wallet badge folder
 * @param locale Locale code (e.g., 'fr-FR', 'en-US')
 * @returns Apple folder code (e.g., 'FR', 'US_UK')
 */
export function mapLocaleToAppleFolder(locale: string): string {
    const normalizedLocale = locale.toLowerCase();

    // Try exact match first
    if (LOCALE_TO_APPLE_FOLDER[normalizedLocale]) {
        return LOCALE_TO_APPLE_FOLDER[normalizedLocale];
    }

    // Try language code only (e.g., 'fr' from 'fr-FR')
    const languageCode = normalizedLocale.split('-')[0];
    if (LOCALE_TO_APPLE_FOLDER[languageCode]) {
        return LOCALE_TO_APPLE_FOLDER[languageCode];
    }

    // Fallback to default
    return DEFAULT_APPLE_FOLDER;
}
